export enum SearchParamsType {
  sortBy = 'sortBy',
  perPage = 'perPage',
  activePage = 'page',
  query = 'query',
}
